import { ActivitySuggestionsTable } from "@/components/activity-suggestions/ActivitySuggestionsTable";
import { PageHeader } from "@/components/shared/page-header";

export function SuggestionsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Activity Suggestions"
        description="Ideas for what to do with your time off."
      />
      <ActivitySuggestionsTable />
    </div>
  );
}
